module.exports = __webpack_public_path__ + "static/img/popcorn.1f89f39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgrounds/popcorn.svg
// module id = 9Wla
// module chunks = 11